import { createAction } from 'redux-actions';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

const openModal = createAction(OPEN_MODAL);
const closeModal = createAction(CLOSE_MODAL);

export default {
    openModal,
    closeModal
};



// WEBPACK FOOTER //
// ./components/modal/modal-actions.js